/* QUESTIONS */
// @ts-nocheck

import { Countdown } from "./trivia/countdown";
import { StartTrivia } from "./trivia/trivia";
import { optionSelect } from "./trivia/optionSelect"
import { viewShow } from "./trivia/functions"
import Petition from "../../../modules/petition"

import { AudioButton } from "./trivia/Audio"

declare global {
  interface Window {
    dama: any;
    datalayer: any;
    SHA256: any;
    drupalSettings: any;
    statusPermits: any;
    welcomeTrivia: any
  }
}

/**
 * Module Question
 *
 */
 export const Question = () => {
  const pt = new Petition();
  startTrivia();
  addLetterAnswer();
};

function startTrivia() {
  let counter = document.getElementById("triviaTime");
  let time = counter.dataset.time;
  let newTime = time ? parseInt(time) : 10;
  welcomeTrivia(newTime);
  optionSelect();
  AudioButton.init();
}

/**
 *
 * @param newTime
 */
const welcomeTrivia = async (newTime: number) => {
  let welcomeTriviaCont = document.getElementById("welcomeTrivia");
  let refwelcomeBtn = welcomeTriviaCont.querySelector(".welcome-trivia__btn");
  let refendBtn = document.querySelector(".btnWatchVideoEnd");

  const stateUser = await checkUser()

  if(stateUser == 'USER_PLAYED'){
    const doneTrivia = document.querySelector("#doneTrivia")
    welcomeTriviaCont.classList.add("view-hidden")
    welcomeTriviaCont.classList.remove("view-showing")
    doneTrivia.classList.add("view-showing")
    return
  }

  let tycCheck = document.querySelector("#tyc");
  let errorMessage = document.querySelector(".error-message-tyc");
  
  tycCheck.addEventListener("change", ()=>{
    !tycCheck.checked ? errorMessage.classList.remove("hidden") : errorMessage.classList.add("hidden")
  })

  viewShow(1)

  /**
   * Click to start trivia
   */
  refwelcomeBtn.addEventListener("click", async () => {

    !tycCheck.checked ? errorMessage.classList.remove("hidden") : errorMessage.classList.add("hidden")
    if(!tycCheck.checked) return

    const inputMarketing:HTMLInputElement  = document.querySelector('input[name="marketing"]:checked')  
    let marketing = 0
    if ( inputMarketing ) marketing = 1

    const cdpUser = await validateSendCDP(marketing)

    // Send datalayer
    sendDatalayer('Iniciar trivia');

    if(stateUser == 'USER_NOT_LOGGED'){
      window.drupalLogin()
      return
    }

    // Show Trivia
    showTrivia(welcomeTriviaCont);
    // Countdown Initialized
    Countdown.init(newTime);
    // Trivia Initialized
    StartTrivia();
    

  });

   /**
   * Click end trivia
   */
    refendBtn.addEventListener("click", () => {

      sendDatalayer('Volver al home');
    });
}

/**
 *
 * @param welcomeTriviaCont
 */
const showTrivia = (welcomeTriviaCont: any) => {
  let triviaCont = document.getElementById("triviaContainer");
  viewShow(2)
  setTimeout(() => triviaCont.classList.add("trivia--started"), 300);
};

const addLetterAnswer = () =>{
  const index = document.querySelectorAll("fieldset.trivia__panel")

  const letter = {
    '0' : 'a&#41',
    '1' : 'b&#41',
    '2' : 'c&#41',
    '3' : 'd&#41',
    '4' : 'e&#41',
    '5' : 'f&#41',
    '6' : 'g&#41',
    '7' : 'h&#41',
    '8' : 'i&#41',
    '9' : 'j&#41',
    '10': 'k&#41',
    '11': 'l&#41',
  }

  index.forEach((item) =>{
    const options = item.querySelectorAll(".textQuestion-id")
    options.forEach((option, index) =>{
      option.textContent = letter[index]
    })
  })
}

async function checkUser(){
    const URL_API = `${window.origin}/trivia/check`
    const res = await fetch(URL_API)
    const response = await res.json() 
    return response  
}

async function validateSendCDP(marketing){
  const URL_API = `${window.origin}/trivia/cdpuser/${marketing}`
  const res = await fetch(URL_API)
  return res.status
}

const sendDatalayer = (action = 'Action') => {

  window.dataLayer.push({
    'event': 'TrackEvent' ,
    'Category': 'Presidente latas',
    'Action': action,
    'Label': 'Clic'
  });
}